import { render } from "./TruckListingCard.vue?vue&type=template&id=240bd932"
import script from "./TruckListingCard.vue?vue&type=script&lang=js"
export * from "./TruckListingCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__